import React from 'react';

import CogIcon from 'components/pure/utils/icon/CogIcon';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';
import {libraryShape} from 'components/Shapes';

class LibrarySettings extends React.PureComponent {
  handleClick(libraryId) {
    setTimeout(() => LibraryCreateActions.editLibrary(libraryId), 0);
  }

  render() {
    const {library} = this.props;

    return <CogIcon onClick={() => this.handleClick(library.id)} />;
  }
}

LibrarySettings.propTypes = {
  library: libraryShape.isRequired,
};

LibrarySettings.displayName = 'LibrarySettings';

export default LibrarySettings;
